import { themeQuartz } from 'ag-grid-community';

export const customAgGridTheme = themeQuartz.withParams({
  accentColor: '#1A936F',
  backgroundColor: '#FFFFFF',
  borderColor: '#03192626',
  borderRadius: 0,
  browserColorScheme: 'inherit',
  cellHorizontalPaddingScale: 1.0516964286,
  chromeBackgroundColor: '#031926',
  fontFamily: 'inherit',
  foregroundColor: '#031926',
  headerBackgroundColor: '#FFFFFF',
  headerFontSize: 14,
  headerTextColor: '#031926',
  headerVerticalPaddingScale: 1.11,
  rowVerticalPaddingScale: 1.0423214286,
  spacing: 6,
  wrapperBorderRadius: 3,
});
